import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { VehicleTypeService } from 'app/services/vehicle-type.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { INT_VEHICLE_TYPE_ACTIONS, VEHICLE_TYPE_ACTIONS } from 'app/shared/actions/actions.constants';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-list-vehicle-type',
  templateUrl: './list-vehicle-type.component.html',
  styleUrls: ['./list-vehicle-type.component.scss']
})
export class ListVehicleTypeComponent implements OnInit {

  vTypes: any = [];
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;
  lblHeading = '';
  selectedVehicleData:any = null;
  @ViewChild('content') modal: NgbModal;
  popoverTitle = 'Delete Vehicle Type';
  popoverMessage = 'Are you sure you want to delete Vehicle Type?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Vehicle Type...";
  vehicleActions = INT_VEHICLE_TYPE_ACTIONS;
  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;
  closeResult: string = '';

  constructor(private service: VehicleTypeService, private modalService: NgbModal, private router: Router,private toastService:ToastNotificationService,
    private utility: UtilityServiceService, private toastr: ToastrService) { }

  ngOnInit() {
    this.onChangeHeandig();
    this.reload();
    this.utility.page = 1;
  }

  reload() {
    this.isLoading = true;
    this.service.getAll().subscribe(result => {
      this.vTypes = result;
      this.utility.onSort(1);
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
    });
  }

  onDelete(id: any) {
    this.service.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Vehicle Type', message: `Vehicle Type ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastService.success(`Vehicle Type ${this.removeRef.code} deleted.`,'Delete Vehicle Type');
      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeandig();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Vehicle Type', message: `Vehicle Type ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastService.error(`Vehicle Type ${this.removeRef.code} was not deleted.`,'Delete Vehicle Type');

    });
  }

  onSort() {
    this.direction = !this.direction;
  }

  onConfirm(doc: any, content) {
    // this.removeRef = doc;
    // this.deleteConfirm = `Are you sure you want to delete Vehicle Type <strong>${this.removeRef.code}</strong>?`;        
    // this.onChangeHeandig(false);
    // this.isRemove = true;
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Carrier Type <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeandig(false);
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        console.log(result);

        this.closeResult = `Closed with: ${result}`;
        // this.activeModal.close()
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Vehicle Types' : 'Delete Vehicle Type';
  }

  CheckedVehicle(event, item) {
    if (event.target.checked) {
      this.selectedVehicleData = item;
    } else {
      this.selectedVehicleData = null;
    }
  }

  doVehicleAction(event: any) {
    if (event.value == VEHICLE_TYPE_ACTIONS.AddVehicle) {
      this.router.navigateByUrl('/vehicle/type/add');
    }
    else if (event.value == VEHICLE_TYPE_ACTIONS.DeleteVehicle) {
      (this.selectedVehicleData == null) ? this.toastr.warning('Please select the vehicle type first!') : this.onConfirm(this.selectedVehicleData, this.modal);
    }
    else {
      if (event.value == VEHICLE_TYPE_ACTIONS.EditVehicle) {
        (this.selectedVehicleData == null) ? this.toastr.warning('Please select the vehicle type first!') : this.router.navigate(['/vehicle/type/edit', this.selectedVehicleData.id]);
      }

    }
  }
}
